module.exports = __webpack_public_path__ + "img/1.aa3dd506.jpg";